import { useRouter } from 'next/navigation';
import { useSession } from 'next-auth/react';

export const useIsAuthorized = (authorizedEmails: string[]) => {
  const router = useRouter();
  const { data } = useSession();
  const email = data?.user?.email;
  const isAuthorized = authorizedEmails.includes(email as string);

  return {
    isAuthorized,
    redirectIfUnauthorized: () => (isAuthorized ? null : router.push('/')),
  };
};
